import React, { useState, useEffect } from 'react';
import PerformanceMonitor from './PerformanceMonitor';
import { PalmRejectionTest } from './PalmRejectionTest';
import { useWhiteboardStore } from '../store/useWhiteboardStore';
import { copyLogsToClipboard, downloadConsoleLogs } from '../utils/consoleLogger';

export const DevTools: React.FC = () => {
  const [showPerformance, setShowPerformance] = useState(false);
  const [showConsoleTools, setShowConsoleTools] = useState(false);
  const { strokes, currentStroke } = useWhiteboardStore();

  // Toggle performance monitor with keyboard shortcut
  useEffect(() => {
    const handleKeyPress = (e: KeyboardEvent) => {
      // Ctrl/Cmd + Shift + P
      if ((e.ctrlKey || e.metaKey) && e.shiftKey && e.key === 'P') {
        e.preventDefault();
        setShowPerformance(prev => !prev);
      }
      // Ctrl/Cmd + Shift + L for console logs
      if ((e.ctrlKey || e.metaKey) && e.shiftKey && e.key === 'L') {
        e.preventDefault();
        setShowConsoleTools(prev => !prev);
      }
    };

    window.addEventListener('keydown', handleKeyPress);
    return () => window.removeEventListener('keydown', handleKeyPress);
  }, []);

  // Only show in development
  if (!import.meta.env.DEV) return null;

  return (
    <>
      <PerformanceMonitor
        visible={showPerformance}
        strokeCount={strokes.length}
        currentStrokeLength={currentStroke.length}
      />
      
      <PalmRejectionTest />
      
      {/* Console Tools */}
      {showConsoleTools && (
        <div
          style={{
            position: 'fixed',
            bottom: '80px',
            right: '10px',
            backgroundColor: 'rgba(17, 24, 39, 0.95)',
            color: '#f3f4f6',
            padding: '15px',
            borderRadius: '8px',
            fontSize: '14px',
            fontFamily: 'monospace',
            border: '1px solid #4b5563',
            zIndex: 1000,
            minWidth: '200px',
            boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
          }}
        >
          <div style={{ marginBottom: '10px', fontWeight: 'bold' }}>Console Logs</div>
          <button
            onClick={async () => {
              const success = await copyLogsToClipboard();
              if (success) {
                alert('Logs copied to clipboard!');
              }
            }}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              width: '100%',
              padding: '8px 12px',
              marginBottom: '8px',
              backgroundColor: '#374151',
              color: '#f3f4f6',
              border: '1px solid #4b5563',
              borderRadius: '4px',
              cursor: 'pointer',
              fontSize: '13px',
            }}
          >
            📋 Copy Logs
          </button>
          <button
            onClick={() => downloadConsoleLogs()}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              width: '100%',
              padding: '8px 12px',
              backgroundColor: '#374151',
              color: '#f3f4f6',
              border: '1px solid #4b5563',
              borderRadius: '4px',
              cursor: 'pointer',
              fontSize: '13px',
            }}
          >
            💾 Download Logs
          </button>
          <div style={{ marginTop: '10px', fontSize: '11px', color: '#9ca3af' }}>
            Press Ctrl+Shift+L to toggle
          </div>
        </div>
      )}
      
      {/* Dev mode indicator */}
      {/* <div
        style={{
          position: 'fixed',
          bottom: '10px',
          left: '10px',
          backgroundColor: 'rgba(59, 130, 246, 0.1)',
          color: '#3b82f6',
          padding: '5px 10px',
          borderRadius: '4px',
          fontSize: '12px',
          fontFamily: 'monospace',
          border: '1px solid #3b82f6',
          pointerEvents: 'none',
          zIndex: 999,
        }}
      >
      
      </div> */}
    </>
  );
};